// === M&A Vibes — interactividad y dinamismo (añadido por Claude) ===
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Barra de progreso de scroll ---
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.id = 'mv-scroll-progress';
    document.body.appendChild(bar);

    var ticking = false;
    function update() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? scrollTop / docHeight : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, progress)) + ')';
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  // --- Aparición de secciones al hacer scroll ---
  function markRevealTargets() {
    var sections = document.querySelectorAll('main .shopify-section');
    sections.forEach(function (el, index) {
      if (index === 0) return; // no animar la primera sección (hero) para no retrasar el LCP
      el.classList.add('reveal-on-scroll');
    });
  }

  function observeTargets() {
    var targets = document.querySelectorAll('.reveal-on-scroll:not(.is-visible)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  // --- Parallax suave en la imagen del hero ---
  function initHeroParallax() {
    var heroImg = document.querySelector('.hero__media-wrapper img, .hero__media-wrapper video');
    if (!heroImg) return;

    var ticking = false;
    function update() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var offset = Math.min(scrollTop * 0.25, 120);
      heroImg.style.transform = 'translateY(' + offset + 'px) scale(1.05)';
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  // --- Resalte dinámico de la sección "Nuestro producto bestselling" ---
  function highlightBestsellerSection() {
    var sections = document.querySelectorAll('main .shopify-section');
    sections.forEach(function (el) {
      if (/bestselling/i.test(el.textContent || '')) {
        el.classList.add('mv-bestseller-highlight');
      }
    });
  }

  // --- Botón "Pagar contra reembolso" (app Releasit) en producto:
  //     se mantiene siempre visible, pero un poco más pequeño que
  //     "Agregar al carrito", conservando su color original (fondo
  //     marrón, letras blancas). La app pinta este botón con estilos
  //     inline (!important), así que el CSS normal no basta: lo
  //     reforzamos por JS cada vez que la app lo (re)pinta. ---
  function restyleCodButton(el) {
    el.style.setProperty('background', '#7d5449', 'important');
    el.style.setProperty('background-color', '#7d5449', 'important');
    el.style.setProperty('color', '#ffffff', 'important');
    el.style.setProperty('border', '0', 'important');
    el.style.setProperty('border-radius', '8px', 'important');
    el.style.setProperty('font-size', '12.5px', 'important');
    el.style.setProperty('padding', '9px 16px', 'important');
    el.style.setProperty('min-height', 'auto', 'important');

    var span = el.querySelector('span');
    if (span) span.style.setProperty('color', '#ffffff', 'important');

    var svg = el.querySelector('svg');
    if (svg) {
      svg.style.setProperty('fill', '#ffffff', 'important');
      svg.setAttribute('width', '16');
    }
  }

  function initCodButtonRestyle() {
    var applying = false;

    function tryApply() {
      if (applying) return;
      var el = document.getElementById('_rsi-buy-now-button');
      if (!el) return;
      applying = true;
      restyleCodButton(el);
      window.requestAnimationFrame(function () {
        applying = false;
      });
    }

    tryApply();

    var observer = new MutationObserver(function () {
      tryApply();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  function init() {
    initScrollProgress();
    initCodButtonRestyle();

    if (!reducedMotion) {
      markRevealTargets();
      observeTargets();
      initHeroParallax();
      highlightBestsellerSection();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
